import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routing/Routes";
import {
  getLanguages,
  getLangTranslationData,
  setSelectedAppLang,
} from "./pages/AxiosRtk/Miscellaneous";
import * as misc from "./../app/pages/AxiosRtk/Miscellaneous";
import { useDispatch, useSelector } from "react-redux";
import SuccessMessageCommon from "./pages/components/modals/SuccessMessageCommon";
import InfoMessageCommon from "./pages/components/modals/InfoMessageCommon";
import ErrorCommonMsg from "./pages/components/modals/ErrorCommonMsg";
import EmailVerificationModal from "./pages/components/modals/EmailVerificationModal";
import useFirebase from "../useFirebase";

function App({ basename }) {
  const dispatch = useDispatch();
  const { getCollectionData } = useFirebase();
  const {
    showMessage,
    defaultMessage,
    message,
    showInfo,
    errorInfo,
    title,
    defaultTitle,
    showEmailVerification,
    callFunOnGotIt,
  } = useSelector(({ successData }) => successData);
  const pathname = window.location.pathname;

  const { appLanguageId, emailVerifiedAppLanguageId } = useSelector(
    ({ misc }) => misc
  );
  const { AdminSetRuleLanguageData } = useSelector(({ setRules }) => setRules);

  const { getCountryList, getTimezoneList, setTimezoneList, setLanguageList } =
    misc;

  useEffect(() => {
    const lang = AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
    dispatch(setSelectedAppLang(lang));
    if (lang?.isRTL === 1) {
      document?.body?.classList?.add("rtl-apply");
    } else {
      document?.body?.classList?.remove("rtl-apply");
    }
    if (pathname !== "/email-verified") {
      getLangTranslationData(appLanguageId ?? 1)
        .then((res) => {
          dispatch(misc?.setTranslationLangList(res?.data?.result));
        })
        .catch((err) => console.log(err?.response?.data?.message));

      getCountryList(appLanguageId ?? 1)
        .then((res) => {
          dispatch(misc?.setCountryList(res?.data?.result));
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
        });
    }
  }, [dispatch, appLanguageId]);

  useEffect(() => {
    if (pathname === "/email-verified" && emailVerifiedAppLanguageId > 0) {
      getLangTranslationData(emailVerifiedAppLanguageId)
        .then((res) => {
          dispatch(misc?.setTranslationLangList(res?.data?.result));
        })
        .catch((err) => console.log(err?.response?.data?.message));

      getCountryList(emailVerifiedAppLanguageId)
        .then((res) => {
          dispatch(misc?.setCountryList(res?.data?.result));
        })
        .catch((err) => {
          console.log(err?.response?.data?.message);
        });
    }
  }, [emailVerifiedAppLanguageId]);

  useEffect(() => {
    // get time zone ids list
    getTimezoneList()
      .then((res) => {
        dispatch(setTimezoneList(res?.data?.result));
      })
      .catch((err) => {
        console.log(
          "Timezone list catch error ==>>",
          err?.data?.response?.message
        );
      });

    getLanguages()
      .then((res) => {
        dispatch(setLanguageList(res.data.result));
      })
      .catch((err) => {
        console.log("get languages api error ==>>", err.response.data.message);
      });

    // getting collection data of admin panel langauge
    getCollectionData("AdminSetRuleData", "Languages");
  }, [dispatch]);

  return (
    <>
      <SuccessMessageCommon
        showModal={showMessage}
        defaultMessage={defaultMessage}
        message={message}
        callFunOnGotIt={callFunOnGotIt}
      />
      <InfoMessageCommon
        showModal={showInfo}
        defaultMessage={defaultMessage}
        message={message}
        title={title}
        defaultTitle={defaultTitle}
      />
      <ErrorCommonMsg
        showModal={errorInfo}
        defaultMessage={defaultMessage}
        message={message}
        title={title}
        defaultTitle={defaultTitle}
      />
      <EmailVerificationModal showModal={showEmailVerification} />

      <BrowserRouter basename={basename}>
        <Routes />
      </BrowserRouter>
    </>
  );
}

export default App;
